import { render, staticRenderFns } from "./bnrFlotilla.vue?vue&type=template&id=26ac183e&scoped=true"
import script from "./bnrFlotilla.vue?vue&type=script&lang=js"
export * from "./bnrFlotilla.vue?vue&type=script&lang=js"
import style0 from "./bnrFlotilla.vue?vue&type=style&index=0&id=26ac183e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26ac183e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VButton: require('/var/www/tubber-new/components/global/v/button.vue').default})
